import React from "react";
import { SanityFormHiddenValueField } from "../models/form/SanityFormField";
import { SanityFormProps } from "../models/form/SanityFormProps";
import { LinkInfo } from "../models/shared/LinkInfo";
import { SanityImageSourceExt } from "../models/shared/SanityImageSourceExt";
import { isNullOrWhiteSpace } from "../shared/string";
import { isValidLink } from "../utilities/links";
import Button, { ButtonSize } from "./Buttons/Button";
import SanityForm from "./Form/SanityForm";
import { FormSelectorDropdown } from "./FormSelectorDropdown";

export interface FormSelectorProps {
  title?: string;
  items?: FormSelectorItemProps[];
}

export interface FormSelectorItemProps {
  title?: string;
  form?: SanityFormProps;
  image?: SanityImageSourceExt;
  displayType?: "form" | "link";
  link?: LinkInfo;
  formHiddenValue?: SanityFormHiddenValueField;
}

export const FormSelector = ({ title, items }: FormSelectorProps) => (
  <div className="relative w-full mx-auto mb-12 px-4 md:px-6 lg:mb-32 max-w-3xl">
    {!isNullOrWhiteSpace(title) && <h2>{title}</h2>}

    <div className="flex flex-col gap-8">
      {items &&
        items.map((item, index) => (
          <FormSelectorDropdown key={index} title={item.title} image={item.image}>
            {item.displayType === "form" && item.form && (
              <SanityForm
                {...item.form}
                hiddenValues={item.formHiddenValue && [item.formHiddenValue]}
              />
            )}

            {item.displayType === "link" && isValidLink(item.link) && (
              <div className="flex justify-center">
                <Button
                  size={ButtonSize.Normal}
                  color="secondary"
                  type="link"
                  {...item.link}
                >
                  {item.link.title}
                </Button>
              </div>
            )}
          </FormSelectorDropdown>
        ))}
    </div>
  </div>
);
